import { notify } from "@kyvg/vue3-notification";

/**
 * Show notification message using vue3-notification
 * @param {Object} payload - The notification payload
 * @param {string} payload.message - The message to display
 * @param {string} payload.messageType - The type of message (success, error, warning, info)
 * @param {string} payload.messageTitle - The title of the message
 * @param {Object} payload.data - Additional data object
 */
export const showMessage = (payload) => {
  const { message, messageType, messageTitle, data } = payload;

  if (data?.message) {
    notify({
      title: messageTitle || "Notification",
      text: data.message,
      type: messageType || "info",
    });
  } else if (message) {
    notify({
      title: messageTitle || "Notification",
      text: message,
      type: messageType || "info",
    });
  }
};

/**
 * Show success notification
 * @param {string} message - The success message
 * @param {string} title - The notification title (optional)
 */
export const showSuccess = (message, title = "Success") => {
  notify({
    title,
    text: message,
    type: "success",
  });
};

/**
 * Show error notification
 * @param {string} message - The error message
 * @param {string} title - The notification title (optional)
 */
export const showError = (message, title = "Error") => {
  notify({
    title,
    text: message,
    type: "error",
  });
};

/**
 * Show warning notification
 * @param {string} message - The warning message
 * @param {string} title - The notification title (optional)
 */
export const showWarning = (message, title = "Warning") => {
  notify({
    title,
    text: message,
    type: "warn",
  });
};

/**
 * Show info notification
 * @param {string} message - The info message
 * @param {string} title - The notification title (optional)
 */
export const showInfo = (message, title = "Info") => {
  notify({
    title,
    text: message,
    type: "info",
  });
};
